import BillOfLading from "./BillOfLading";
export default BillOfLading;
